import type { BarDatum } from "@nivo/bar";

import React from "react";

import type { Graphs } from "../../types";

import { Typo } from "../../../Typo";

type BarChartTooltipProps = {
  translations: Graphs;
  data: BarDatum;
};
export const BarChartTooltip = ({
  translations,
  data,
}: BarChartTooltipProps) => {
  if (!data.label) return <></>;

  const { color, label, clientCount, volume, volumeUSD } = data;
  const borderColor = color.toString() || "bg-gray-300";

  return (
    <div className="relative flex rounded-xl bg-white p-3 shadow-md">
      <div
        className="absolute bottom-3 left-3 top-3 w-1 rounded-full bg-current"
        style={{ backgroundColor: borderColor }}
      ></div>

      <div className="flex flex-col gap-1 pl-3 text-sm">
        <div className="text-xs font-semibold text-text-primary">{label}</div>

        <div className="text-[10px] font-normal text-text-tertiary">
          {translations.clientLabelTooltip}
        </div>
        <div className="text-xs font-semibold text-text-primary">
          {clientCount}
        </div>

        <div className="text-[10px] font-normal text-text-tertiary">
          {translations.volume}
        </div>

        <div className="flex items-baseline gap-1">
          <Typo type="labelXS">US${volumeUSD}</Typo>
          <Typo type="label2XS" textColor="text-text-secondary">
            ({volume} {translations.lots.toLowerCase()})
          </Typo>
        </div>
      </div>
    </div>
  );
};

export const BarChartTooltipMemo = React.memo(
  BarChartTooltip,
  (prevProps, nextProps) => {
    return (
      prevProps.data.label === nextProps.data.label &&
      prevProps.data.volume === nextProps.data.volume &&
      prevProps.data.clientCount === nextProps.data.clientCount &&
      prevProps.data.volumeUSD === nextProps.data.volumeUSD
    );
  },
);
